module.exports = __webpack_public_path__ + "static/media/ffOutline.bf69bd57.svg";